import CityZoneHub from "../components/CityZoneHub";

export default function Page() {
  return (
    <CityZoneHub
      name="Marbella"
      slug="marbella"
      poblacion={160000}
      lat={36.5099}
      lng={-4.8826}
      neighborhoodsText="Trabajamos en toda Marbella y sus zonas residenciales premium: Puerto Banús, Nueva Andalucía, Sierra Blanca, Golden Mile, Elviria, Los Monteros, San Pedro de Alcántara y Las Chapas. Especialistas en villas de lujo y urbanizaciones cerradas."
      faqItems={[
        { question: "¿Cuánto tarda en llegar el equipo a Marbella?", answer: "Visita en menos de 24h, generalmente el mismo día." },
        { question: "¿Trabajan en urbanizaciones cerradas de Marbella?", answer: "Sí, coordinamos con la administración o el conserje." },
        { question: "¿Atienden en inglés/francés?", answer: "Sí, atendemos en español, inglés y francés." },
      ]}
    />
  );
}